import axios from '@/libs/api.request';

export const getAdList = data => {
    return axios.request({
        url: 'web/systemManagement/ad/getPageAdList',
        data: data,
        method: 'post'
    });
};

export const saveAd = data => {
    return axios.request({
        url: 'api/systemManagement/ad/saveAd',
        data: data,
        method: 'post'
    });
};
